import React from 'react';
import './StartKeys.css';
import RiddleCard from '../RiddleCard/RiddleCard';

const KeySVG = ({ solved, label }) => (
    <div className="key-slot">
        <div className={`key-cylinder ${solved ? 'turned' : ''}`}>
            <div className={`key-wrapper ${solved ? 'turned' : ''}`}>
                <svg
                    className="key-svg"
                    viewBox="0 0 40 100"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Key bow (head) */}
                    <circle cx="20" cy="16" r="13" className="key-bow" />
                    <circle cx="20" cy="16" r="7" className="key-hole" />

                    {/* Key shaft */}
                    <rect x="17" y="28" width="6" height="50" rx="2" className="key-shaft" />

                    {/* Key cuts */}
                    <rect x="23" y="42" width="5" height="4" rx="1" className="key-cut" />
                    <rect x="23" y="54" width="5" height="4" rx="1" className="key-cut" />
                    <rect x="23" y="66" width="3" height="4" rx="1" className="key-cut" />
                </svg>
            </div>
        </div>
        <span className="key-label">{label}</span>
    </div>
);

const StartKeys = ({ solved, pins, connected }) => {
    const key1Solved = pins?.length > 0 ? pins[0].solved : solved;
    const key2Solved = pins?.length > 1 ? pins[1].solved : solved;

    const mainDiv = (
        <div className="start-keys-container">
            <KeySVG solved={key1Solved} label="Key 1" />
            <KeySVG solved={key2Solved} label="Key 2" />
        </div>
    );

    return (
        <RiddleCard
            title="Start Keys"
            allSolved={solved}
            mainInfo={mainDiv}
            connected={connected}
            layout="half-size"
            center={true}
        />
    );
};

export default StartKeys;
